<h4 class="mb-3 fw-bold text-black">Dashboard</h4>
<div class="row g-4 justify-content-center">
  <!-- Post Jobs -->
  <div class="col-md-6 col-lg-3">
    <div class="card h-100 border-0">
      <div class="card-body bg1 d-flex flex-column">
        <h6 class="card-title d-flex gap-3 align-items-center">
          <i class="fa-solid fa-briefcase card-icon"></i> Post Jobs
        </h6>
        <span class="badge rounded-pill custom-badge">{{ data.jobs }}</span>
        <!-- <p class="card-text text-secondary">Create job listings and manage candidate applications.</p> -->
        <a href="/careers" class="btn custom-btn mt-auto">Go to Jobs</a>
      </div>
    </div>
  </div>

  <!-- Manage Users -->
  <div class="col-md-6 col-lg-3">
    <div class="card h-100 border-0">
      <div class="card-body bg2 d-flex flex-column">
        <h6 class="card-title d-flex gap-3 align-items-center">
          <i class="fa-solid fa-users card-icon"></i> Manage Users
        </h6>
        <span class="badge rounded-pill custom-badge">{{ data.users }}</span>
        <!-- <p class="card-text text-secondary">Handle user accounts and respond to their queries.</p> -->
        <a href="/users" class="btn custom-btn mt-auto">Go to Users</a>
      </div>
    </div>
  </div>

  <!-- Newsletter Blog -->
  <div class="col-md-6 col-lg-3">
    <div class="card h-100 border-0">
      <div class="card-body bg3 d-flex flex-column">
        <h6 class="card-title d-flex gap-3 align-items-center">
          <i class="fa-solid fa-newspaper card-icon"></i> Newsletter Blog
        </h6>
        <span class="badge rounded-pill custom-badge">{{ data.blogs }}</span>
        <!-- <p class="card-text text-secondary">Write and publish updates for your subscribers.</p> -->
        <a href="/blog" class="btn custom-btn mt-auto">Go to Blog</a>
      </div>
    </div>
  </div>

  <!-- Bug Reporting -->
  <div class="col-md-6 col-lg-3">
    <div class="card h-100 border-0">
      <div class="card-body bg4 d-flex flex-column">
        <h6 class="card-title d-flex gap-3 align-items-center">
          <i class="fa-solid fa-bug card-icon"></i> Bug Reporting
        </h6>
        <span class="badge rounded-pill custom-badge">{{ data.bugs }}</span>
        <!-- <p class="card-text text-secondary">Report bugs or request technical assistance.</p> -->
        <a href="/bug-logs" class="btn custom-btn mt-auto">Report a Bug</a>
      </div>
    </div>
  </div>
</div>
